import { render, staticRenderFns } from "./GrossPayChart.vue?vue&type=template&id=098bbc25&scoped=true"
import script from "./GrossPayChart.vue?vue&type=script&lang=js"
export * from "./GrossPayChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bbc25",
  null
  
)

export default component.exports